import { Link, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { api } from "@/lib/api";
import { useSettings } from "@/contexts/SettingsContext";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Logo } from "@/components/Logo";

export const ArticleDetailPage = () => {
  const { slug } = useParams();
  const { settings } = useSettings();
  const { data, isLoading } = useQuery({
    queryKey: ["article", slug],
    queryFn: async () => (await api.get(`/articles/${slug}`)).data,
    retry: 1,
  });
  const article = data && typeof data === "object" && "title" in data ? data : null;

  return (
    <div className="bg-cream min-h-screen">
      <header className="border-b border-border/60">
        <div className="px-6 md:px-10 py-5 flex items-center justify-between max-w-3xl mx-auto">
          <Link to="/" className="font-brand font-bold text-xl tracking-tight text-ink flex items-center gap-2">
            <Logo src={settings.logo_url} size={28} />
            {settings.brand_name}
          </Link>
          <Link
            to="/artikel"
            className="inline-flex items-center gap-2 text-sm font-medium text-stone2 hover:text-honey transition-colors duration-300"
          >
            <ArrowLeft size={16} />
            Semua Artikel
          </Link>
        </div>
      </header>

      <article className="px-6 md:px-10 py-12 md:py-20 max-w-3xl mx-auto">
        {isLoading && <p className="text-stone2">Memuat artikel...</p>}
        {!isLoading && !article && <p className="text-stone2">Artikel tidak ditemukan.</p>}
        {article && (
          <>
            <h1 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05] text-ink mb-6">
              {article.title}
            </h1>
            {article.cover_image && (
              <div className="overflow-hidden rounded-[1.75rem] mb-10">
                <img src={article.cover_image} alt={article.title} className="w-full h-auto object-cover" />
              </div>
            )}
            <div className="article-content text-stone2 leading-relaxed text-base md:text-lg">
              <ReactMarkdown remarkPlugins={[remarkGfm]}>{article.content}</ReactMarkdown>
            </div>
          </>
        )}
      </article>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
};
